<template>
  <div class="collapse show collapse-horizontal aside col-lg-2" id="collapseWidthExample">
    <div class="aside-inner">
      <div class="aside-inner-title">영업기회 관리</div>
      <div class="accordion" id="accordionExample">
        
        <template v-for="depth1 in state.SnbDepth1" :key="depth1.key" >
          <template v-if="depth1.access">

            <div class="accordion-item">
              <h2 class="accordion-header">
                <ElButton type="accordionSide" :target="depth1.key" :active="isCollapseShow(depth1.showMenuId)">
                  {{ depth1.name }}
                </ElButton>
              </h2>
              <div :id="depth1.key" :class="[isCollapseShow(depth1.showMenuId) ? 'accordion-collapse collapse show' : 'accordion-collapse collapse']">
                <div class="accordion-body">
                  <ul class="accordion-submenu">
                    <template v-for="item in state.snbDepth2" :key="item.key">
                      <li v-if="item.access && depth1.key == item.key">
                        <router-link 
                          :class="checkActive(item)"
                          :to="item.link"
                        >
                          {{ item.name }}
                        </router-link>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
          </template>
        </template> 
      </div>
    </div>      
  </div>
 
</template>

<script setup>
import { router } from '@/router';
import {computed} from 'vue'
import { useRoute } from "vue-router";
import { useUserStore } from '@/store/user';
const route = useRoute()
const userStore = useUserStore()


const state = computed(()=>{
  const data = {
    SnbDepth1 :[
          {key : 'sa1',name:'영업기회 알람기능', link :'',id:'M002M001',access:false,showMenuId:['MSM_SA_001','MSM_SA_002','MSM_SA_003','MSM_SA_010']},
          {key : 'sa2',name:'리드 관리', link :'',id:'M002M002',access:false,showMenuId:['MSM_SA_004','MSM_SA_005','MSM_SA_006','MSM_SA_011']},
          {key : 'sa3',name:'이벤트 관리', link :'',id:'M002M003',access:false,showMenuId:['MSM_SA_007','MSM_SA_008','MSM_SA_009','MSM_SA_012']},
  
      ],
      snbDepth2 : [
          {key : 'sa1',name:'영업기회 알람 등록/수정',link : '/sm/MSM_SA_001' ,id:'M002M001M001',access:false,activeLink : ['/sm/MSM_SA_001','/sm/MSM_SA_003']},
           {key : 'sa1',name:'영업기회 알람 조회',  link : '/sm/MSM_SA_002' ,id:'M002M001M002',access:false},
      
          {key : 'sa2',name:'리드 등록/수정',link : '/sm/MSM_SA_004' ,id:'M002M002M001',access:false,activeLink : ['/sm/MSM_SA_004','/sm/MSM_SA_006']},
          {key : 'sa2',name:'리드 조회',link : '/sm/MSM_SA_005' ,id:'M002M002M002',access:false},
           
          {key : 'sa3',name:'이벤트 등록/수정',link : '/sm/MSM_SA_007' ,id:'M002M003M001',access:false,activeLink : ['/sm/MSM_SA_007','/sm/MSM_SA_009']},
          {key : 'sa3',name:'이벤트 조회',link : '/sm/MSM_SA_008' ,id:'M002M003M002',access:false},
      ],
      keyStatus : ''
  }

  const menuList = Object.keys(data).filter(name => name.includes('Depth'))

  menuList.forEach((depth)=>{
    data[depth].forEach((item)=>{
      if (userStore.user) {
        item.access = item.id ? userStore.user.mnUrl.includes(item.id) : true
      }
    })
  })


  Object.values(data).forEach(datum => {
    Object.values(datum).forEach(item => {
      if (item.link.toLowerCase() === route.path.toLowerCase()) {
        if(userStore.user && !item.access){
          alert('접근 불가한 페이지입니다.')
          router.push('/')
          return
        }
        data.keyStatus = item.key
      }
    })
  })


  return data
})

function isCollapseShow(menuList){
  let pathNm = location.pathname.split('/')[location.pathname.split('/').length-1]
  return menuList.includes(pathNm)
}

function checkActive(item){
  let activeFlag = false
  if(item.activeLink){
    activeFlag = item.activeLink.includes(location.pathname)
  }else{
    activeFlag = item.link === location.pathname
  }

  return activeFlag ? 'route-active' : ''
}

</script>